import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdmin } from '../../contexts/AdminContext';
import AdminLayout from '../../components/admin/AdminLayout';
import { Save } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminMetrics = () => {
  const { getAuthHeaders } = useAdmin();
  const [formData, setFormData] = useState({
    members: '',
    age_group: '',
    cities: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchMetrics();
  }, []);

  const fetchMetrics = async () => {
    try {
      const response = await axios.get(`${API}/admin/metrics`, getAuthHeaders());
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching metrics:', error);
      // Set default values if not found
      setFormData({
        members: '120+',
        age_group: '18-35',
        cities: '6'
      });
    }
    setLoading(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/metrics`, formData, getAuthHeaders());
      alert('Metrics updated successfully!');
    } catch (error) {
      console.error('Error saving metrics:', error);
      alert('Error saving changes: ' + (error.response?.data?.detail || error.message));
    }
    setSaving(false);
  };

  if (loading) return <AdminLayout><p className="text-white">Loading...</p></AdminLayout>;

  return (
    <AdminLayout>
      <div className="space-y-6">
        <h1 className="display-medium text-white">Site Metrics</h1>
        <p className="body-medium text-white/60">These metrics are displayed on the home page</p>

        <div className="bg-white/10 border border-white/25 p-6 rounded-lg">
          <div className="space-y-4">
            <div>
              <label className="body-small text-white mb-1 block">Community Members</label>
              <input
                type="text"
                value={formData.members}
                onChange={(e) => setFormData({ ...formData, members: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
                placeholder="e.g., 120+"
                data-testid="metrics-members-input"
              />
            </div>

            <div>
              <label className="body-small text-white mb-1 block">Typical Age Group</label>
              <input
                type="text"
                value={formData.age_group}
                onChange={(e) => setFormData({ ...formData, age_group: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
                placeholder="e.g., 18-35"
                data-testid="metrics-age-input"
              />
            </div>

            <div>
              <label className="body-small text-white mb-1 block">Cities Covered</label>
              <input
                type="text"
                value={formData.cities}
                onChange={(e) => setFormData({ ...formData, cities: e.target.value })}
                className="w-full bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
                placeholder="e.g., 6"
                data-testid="metrics-cities-input"
              />
            </div>

            <button 
              onClick={handleSave} 
              disabled={saving} 
              className="btn-primary flex items-center gap-2"
              data-testid="save-metrics-btn"
            >
              <Save size={20} /> {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminMetrics;
